__turbopack_context__.v({
  "count": "ProjectFlow-module__4oTMLa__count",
  "dot": "ProjectFlow-module__4oTMLa__dot",
  "dotIdle": "ProjectFlow-module__4oTMLa__dotIdle",
  "dotReached": "ProjectFlow-module__4oTMLa__dotReached",
  "drift": "ProjectFlow-module__4oTMLa__drift",
  "float": "ProjectFlow-module__4oTMLa__float",
  "grid": "ProjectFlow-module__4oTMLa__grid",
  "label": "ProjectFlow-module__4oTMLa__label",
  "link": "ProjectFlow-module__4oTMLa__link",
  "linkActive": "ProjectFlow-module__4oTMLa__linkActive",
  "links": "ProjectFlow-module__4oTMLa__links",
  "nebula": "ProjectFlow-module__4oTMLa__nebula",
  "node": "ProjectFlow-module__4oTMLa__node",
  "orb": "ProjectFlow-module__4oTMLa__orb",
  "packet": "ProjectFlow-module__4oTMLa__packet",
  "packetFlow": "ProjectFlow-module__4oTMLa__packetFlow",
  "packets": "ProjectFlow-module__4oTMLa__packets",
  "pulseHalo": "ProjectFlow-module__4oTMLa__pulseHalo",
  "scene": "ProjectFlow-module__4oTMLa__scene",
  "stage": "ProjectFlow-module__4oTMLa__stage",
});
